import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';

import {NextTask} from './NextTask';

export default connect(
  createStructuredSelector({
    featureFlag: variablesFeatureFlag,
  }),
)(NextTask);
